module.exports = __webpack_public_path__ + "media/images/meta/kinrgy/favicon-314d46a18363db8d2051c21646636e8c.png";